export const iconMap = {
  0: { src: '/weather/Tornado.svg', alt: 'Tornado' },
  1: { src: '/weather/Tropical Storm.svg', alt: 'Tropical Storm' },
  2: { src: '/weather/Hurricane.svg', alt: 'Hurricane' },
  3: { src: '/weather/Thunderstorms.svg', alt: 'Strong Storms' },
  4: { src: '/weather/Thunderstorms.svg', alt: 'Thunderstorms' },
  5: { src: '/weather/Snow_To_Rain.svg', alt: 'Rain or Snow' },
  6: { src: '/weather/Rain_Freezing_Rain.svg', alt: 'Rain or Sleet' },
  7: { src: '/weather/Wintry_Mix.svg', alt: 'Wintry Mix' },
  8: { src: '/weather/FreezingDrizzle.svg', alt: 'Freezing Drizzle' },
  9: { src: '/weather/Drizzle.svg', alt: 'Drizzle' },
  10: { src: '/weather/Rain_Freezing_Rain.svg', alt: 'Freezing Rain' },
  11: { src: '/weather/Rain_light.svg', alt: 'Showers' },
  12: { src: '/weather/Rain_Moderate.svg', alt: 'Rain' },
  13: { src: '/weather/Cloudy_Flurries.svg', alt: 'Flurries' },
  14: { src: '/weather/Snow_Light.svg', alt: 'Snow Showers' },
  15: { src: '/weather/Snow_Windy.svg', alt: 'Blowing or Drifting Snow' },
  16: { src: '/weather/Snow_Moderate.svg', alt: 'Snow' },
  17: { src: '/weather/Sleet_Freezing_Rain.svg', alt: 'Hail' },
  18: { src: '/weather/Sleet.svg', alt: 'Sleet' },
  19: { src: '/weather/Fog.svg', alt: 'Blowing Dust or Sandstorm' },
  20: { src: '/weather/Fog.svg', alt: 'Foggy' },
  21: { src: '/weather/Fog.svg', alt: 'Haze' },
  22: { src: '/weather/Fog.svg', alt: 'Smoke' },
  23: { src: '/weather/Cloudy_Breezy.svg', alt: 'Breezy' },
  24: { src: '/weather/Cloudy_Breezy.svg', alt: 'Breezy' },
  25: { src: '/weather/Flurries_Breezy.svg', alt: 'Frigid or Ice Crystals' },
  26: { src: '/weather/Cloudy.svg', alt: 'Cloudy' },
  27: { src: '/weather/PM_Cloudy_Mostly.svg', alt: 'Mostly Cloudy Night' },
  28: { src: '/weather/Cloudy_Mostly.svg', alt: 'Mostly Cloudy' },
  29: { src: '/weather/PM_Cloudy_Partly.svg', alt: 'Partly Cloudy Night' },
  30: { src: '/weather/Sunny_Partly.svg', alt: 'Partly Cloudy' },
  31: { src: '/weather/PM_Clear.svg', alt: 'Clear' },
  32: { src: '/weather/Sunny.svg', alt: 'Sunny' },
  33: { src: '/weather/PM_Cloudy_Partly.svg', alt: 'Fair or Mostly Clear' },
  34: { src: '/weather/Sunny_Mostly.svg', alt: 'Fair or Mostly Sunny' },
  35: { src: '/weather/AM_Cloudy Mix.svg', alt: 'Mixed Rain and Hail' },
  36: { src: '/weather/Sunny.svg', alt: 'Sunny' },
  37: { src: '/weather/Sun_Thunderstorm.svg', alt: 'Isolated Thunderstorms' },
  38: { src: '/weather/Thunderstorms.svg', alt: 'Scattered Thunderstorms' },
  39: { src: '/weather/Sun_AM_Showers.svg', alt: 'Scattered Showers' },
  40: { src: '/weather/Rain_Heavy.svg', alt: 'Heavy Rain' },
  41: { src: '/weather/Sun_Snow Showers.svg', alt: 'Scattered Snow Shower' },
  42: { src: '/weather/Snow_Heavy.svg', alt: 'Heavy Snow' },
  43: { src: '/weather/Blizzard.svg', alt: 'Blizzard' },
  45: { src: '/weather/Night Rain Showers.svg', alt: 'Scattered Showers Night' },
  46: { src: '/weather/PM_Snow_Showers.svg', alt: 'Scattered Showers Night' },
  47: { src: '/weather/PM_Thunderstorms.svg', alt: 'Scattered Thunderstorms Night' }
}
